import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface BulkUpdateGLCodeRequest {
  departments: number[];
  glCodes: number[];
  assign: boolean;
}

const useBulkUpdateGLCodeApi = (companyId: string) => {
  const call = useCallback(
    async (body?: BulkUpdateGLCodeRequest) => {
      try {
        const res = await axiosInstance.post(api.bulkUpdateGLCode(companyId), body);
        return res;
      } catch (error) {
        throw new Error(error);
      }
    },
    [companyId]
  );

  const { execute, isLoading } = useAsync(call, false);

  return { bulkUpdateGLCode: execute, isBulkUpdateGLCodeLoading: isLoading };
};

export default useBulkUpdateGLCodeApi;
